module.exports = __webpack_public_path__ + "static/image2-eaa95619643f28f700426bfe25a6a95e.jpg";